const initialState = {
  data: {
    size: 0,
    totalElements: 0,
    totalPages: 0,
    currentPage: 0,
    Panels: []
  },
  isLoading: false,
  hasErrored: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case '[EXPLORER] HAS_ERRORED':
      return { ...state, isLoading: false, data: initialState.data, hasErrored: true };
    case '[EXPLORER] IS_LOADING':
      return { ...state, hasErrored: false, data: initialState.data, isLoading: true };
    case '[EXPLORER] FETCH_SUCCESS':
      return { ...state, hasErrored: false, isLoading: false, data: action.data };
    case '[EXPLORER] COUNT_HAS_ERRORED':
      return { ...state, isLoading: false, data: initialState.data, hasErrored: true };
    case '[EXPLORER] COUNT_IS_LOADING':
      return { ...state, hasErrored: false, data: initialState.data, isLoading: true };
    case '[EXPLORER] COUNT_FETCH_SUCCESS':
      return { ...state, hasErrored: false, isLoading: false, dataCount: action.data };
    case '[EXPLORER] COUNT_FAILS':
      return { ...state, countFails: action.countFails };
    default:
      return state;
  }
};
